<template>
  <div class="app-container">
    <BjPage
      ref="BjPage"
      :bj-page-document-id="BjPageDocumentId"
      :query-params="queryParams"
      :col-span="colSpan"
      :get-action="queryApi"
      :serial="serial"
      :selection="selection"
      row-key="tenantId"
      :row-style="rowStyleFun"
      @handleSelectionChange="handleSelectionChange"
      @showSetting="SortableTable.show"
      @header-dragend="SortableTable.handleHeaderDragend"
      @header-contextmenu="SortableTable.handleHeaderContextmenu"
    >
      <template v-slot:baseForm>
        <el-col :span="colSpan">
          <el-form-item label="租户名称" prop="tenantName">
            <BjInput
              v-model="queryParams.tenantName"
              :maxlength="MAX_LENGTH.DEFAULT"
              placeholder="请输入"
              clearable
              @keyup.enter.native="handleQuery"
            /> </el-form-item
        ></el-col>
        <el-col :span="colSpan">
          <el-form-item label="状态" prop="enabledFlag">
            <BjSelectLov
              v-model="queryParams.activeFlag"
              :option-list="STATUS_ENABLED_NUM"
              placeholder="请选择"
            />
            <!-- <el-select v-model="queryParams.enabledFlag" placeholder="请选择" clearable class="full-width">
              <el-option
                v-for="item in STATUS_ENABLED_NUM"
                :key="item.label"
                :label="item.label"
                :value="item.value"
              />
            </el-select> -->
          </el-form-item></el-col
        >
        <el-col :span="colSpan">
          <el-form-item label="是否过期" prop="activeFlag">
            <BjSelectLov
              v-model="queryParams.activeFlag"
              :option-list="STATUS_YES_TRUE"
              placeholder="请选择"
            /> </el-form-item
        ></el-col>
        <el-col :span="colSpan">
          <el-form-item label="有效期起" prop="startDateActive">
            <el-date-picker
              v-model="queryParams.startDateActive"
              class="full-width"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="请选择"
              @change="handleChangeStartTime"
            /> </el-form-item
        ></el-col>
        <el-col :span="colSpan">
          <el-form-item label="有效期止" prop="endDateActive">
            <el-date-picker
              v-model="queryParams.endDateActive"
              class="full-width"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="请选择"
              :picker-options="$disabledPickerDate(queryParams.startDateActive)"
            /> </el-form-item
        ></el-col>
      </template>
      <template v-slot:tableOperation>
        <el-col>
          <el-button
            v-permission:SettingTenantManage_Add
            type="primary"
            class="main-btn"
            @click="onAdd"
            >创建租户</el-button
          >
        </el-col>
      </template>
      <template v-slot:tableColumn>
        <template v-for="(col, index) in $filterCols(dropCols)">
          <el-table-column
            v-if="col.prop !== 'bjTableAction'"
            :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop"
            :label="col.label"
            :width="col.width || 'auto'"
            :fixed="col.fixed || false"
            align="center"
            class-name="item"
          >
            <template slot-scope="scope">
              <template v-if="false" />
              <el-tag
                v-else-if="col.prop === 'activeFlag'"
                :type="scope.row.activeFlag ? 'danger' : 'info'"
                >{{ $t(STATUS_YES_TRUE.bjGet(scope.row.activeFlag)) }}</el-tag
              >
              <span v-else-if="col.prop === 'enabledFlag'">{{
                $t(STATUS_ENABLED_NUM.bjGet(scope.row.enabledFlag))
              }}</span>
              <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="col.prop === 'bjTableAction'"
            :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop"
            :label="col.label"
            :width="col.width || 'auto'"
            :fixed="col.fixed || 'right'"
            align="center"
          >
            <template slot-scope="props">
              <el-button
                v-permission:SettingTenantManage_Add
                type="text"
                class="edit-btn"
                @click="onEdit(props.row)"
                >{{ $t('editText') }}</el-button
              >
              <el-button
                v-show="props.row.enabledFlag == 1"
                v-permission:SettingTenantManage_Status
                type="text"
                @click="onStatus(0, props.row)"
                >{{ $t('disableText') }}</el-button
              >
              <el-button
                v-if="props.row.enabledFlag == 0"
                v-permission:SettingTenantManage_Status
                type="text"
                @click="onStatus(1, props.row)"
                >{{ $t('enableText') }}</el-button
              >
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>

    <!-- 新增/编辑弹窗 -->
    <DataForm ref="DataForm" @reFresh="reFresh" />
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import { tenantApi } from '@/api/index';
import { STATUS_ENABLED_NUM, STATUS_YES_NUM, STATUS_YES_TRUE } from '@/utils/constants';
import DataForm from './components/DataForm.vue';
export default {
  name: 'SysOrganizationMaintainIndex',
  components: {
    DataForm,
  },
  mixins: [pageMiXin],
  data() {
    return {
      selection: false,
      queryApi: tenantApi.getTenants,
      labelList: [
        { label: '租户编码', prop: 'tenantNum', isCheck: true, disabled: false },
        { label: '租户名称', prop: 'tenantName', isCheck: true, disabled: false },
        { label: '限制用户数', prop: 'limitUserQty', isCheck: true, disabled: false },
        { label: '是否过期', prop: 'activeFlag', isCheck: true, disabled: false },
        { label: '有效期起', prop: 'startDateActive', isCheck: true, disabled: false },
        { label: '有效期止', prop: 'endDateActive', isCheck: true, disabled: false },
        { label: this.$t('orderNewPatch.Status'), prop: 'enabledFlag', isCheck: true, disabled: false },
        { label: '操作', prop: 'bjTableAction', isCheck: true, disabled: true, width: 129 },
      ],

      STATUS_ENABLED_NUM,
      STATUS_YES_NUM,
      STATUS_YES_TRUE,
      // 查询参数
      queryParams: {
        tenantName: null,
        tenantNum: null,
        enabledFlag: null,
        // customMenuFlag: null,
        createDate: [],
        startDateActive: null,
        endDateActive: null,
      },
    };
  },
  watch: {},
  mounted() {},
  methods: {
    rowStyleFun({ row, rowIndex }) {
      const styleJson = {};
      if (row.activeFlag) {
        styleJson.color = 'red';
      }
      return styleJson;
    },
    /** 新增 */
    onAdd() {
      this.$refs.DataForm.show({
        lovCode: this.queryParams.lovCode,
        lovId: this.queryParams.lovId,
      });
    },
    /** 编辑操作 */
    onEdit(row) {
      tenantApi.detailTenants({id: row.tenantId}).then(res => {
        this.$refs.DataForm.show(this.$lodash.clone(row));
      });
    },
    /** 禁用 */
    onStatus(flag, row) {
      const TEXT = this.$t(STATUS_ENABLED_NUM.bjGet(flag));
      this.$confirm(`您正在 ${TEXT} ${row.tenantName}，是否继续?`, '提示', {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      })
        .then(() => {
          this.operationApi({
            ...row,
            enabledFlag: flag,
          });
        })
        .catch(() => {});
    },
    /** 删除操作 */
    onDelete(row) {
      this.$confirm(`您正在删除 ${row.tenantName}，是否继续?`, '提示', {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      })
        .then(() => {
          this.batchDeleteApi([row]);
        })
        .catch(() => {});
    },
    /** 批量删除操作 */
    onDeleteSelected() {
      if (!this.selectedRows.length) {
        this.$message.warning('请选择');
        return;
      }

      if (this.selectedRows.some(e => e.enabledFlag == 1)) {
        this.$message.warning('您选中了正在启用的数据，不可删除');
        return;
      }

      this.$confirm('您正在删除所选的数据，是否继续？', '提示', {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      })
        .then(() => {
          this.batchDeleteApi(this.selectedRows);
        })
        .catch(() => {});
    },
    operationApi(API_DATA) {
      console.log(API_DATA);
      API_DATA['organizationId'] = API_DATA.tenantId;

      tenantApi.updateTenants(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success('操作成功');
          setTimeout(() => {
            this.reFresh();
          }, 500);
        }
      });
    },
    batchDeleteApi(API_DATA) {},
    handleChangeStartTime(startTime) {
      const { startDateActive, endDateActive } = this.queryParams;
      if (new Date(endDateActive) < new Date(startDateActive)) {
        this.queryParams.endDateActive = null;
      }
    },
  },
};
</script>
